import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation, Navigate } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import { ToastContainer, toast } from "react-toastify";
import { requestPermissionAndRegister, onForegroundMessage } from "./utils/pushNotificationService";
import Login from "./components/auth/login";
import AdminLogin from "./components/admin/adminLogin";
import ManagerLogin from "./components/admin/ManagerLogin";
import AdminDashboard from "./components/admin/adminDashboard";
import DashboardMain from "./components/admin/DashboardMain";
import AdminDashboardLayout from "./components/admin/Dashboard";
import AppUsersPage from "./components/admin/AppUsersPage";
import SiteRegisterPage from "./components/admin/SiteRegisterPage";
import RefusalToWorkFormPage from "./components/admin/RefusalToWorkFormPage";
import RefusalToWorkFormSignaturePage from "./components/admin/RefusalToWorkFormSignaturePage";
import PPESelfCheckFormPage from "./components/admin/PPESelfCheckFormPage";
import PermitToBreakGroundPage from "./components/admin/PermitToBreakGroundPage";
import HseqSiteInspectionPage from "./components/admin/HseqSiteInspectionPage";
import RailHseqSiteInspectionPage from "./components/admin/RailHseqSiteInspectionPage";
import InjuredPersonStatementPage from "./components/admin/InjuredPersonStatementPage";
import BehaviouralExchangeEngineersPage from "./components/admin/BehaviouralExchangeEngineersPage";
import HotWorksPermitPage from "./components/admin/HotWorksPermitPage";
import WitnessStatementPage from "./components/admin/WitnessStatementPage";
import Sf009ACertificateElectricalPage from "./components/admin/Sf009ACertificateElectricalPage";
import Sf009BElectricalIsolationPage from "./components/admin/Sf009BElectricalIsolationPage";
import Sf009DElectricalPermitToWorkPage from "./components/admin/Sf009DElectricalPermitToWorkPage";
import Sf009EElectricalSanctionToTestPage from "./components/admin/Sf009EElectricalSanctionToTestPage";
import Sf009FLimitationOfAccessPage from "./components/admin/Sf009FLimitationOfAccessPage";
import Sf009GRegisterOfCompetentPersonsPage from "./components/admin/Sf009GRegisterOfCompetentPersonsPage";
import Sf009HElectricalAuditInspectionReportPage from "./components/admin/Sf009HElectricalAuditInspectionReportPage";
import Sf009ISwitchRoomElectricalSafetyLogPage from "./components/admin/Sf009ISwitchRoomElectricalSafetyLogPage";
import Sf009JRiskAssessmentSchedulePage from "./components/admin/Sf009JRiskAssessmentSchedulePage";
import Sf009KRiskAssessmentTemplatePage from "./components/admin/Sf009KRiskAssessmentTemplatePage";
import Sf009CSitePermitRegisterPage from "./components/admin/Sf009CSitePermitRegisterPage";
import Sf009LAppointmentAuthorisedPersonAssessmentPage from "./components/admin/Sf009LAppointmentAuthorisedPersonAssessmentPage";
import Sf009MAcceptanceLvElectricalSafetyRulesPage from "./components/admin/Sf009MAcceptanceLvElectricalSafetyRulesPage";
import Sf009NInitialSiteElectricalSafetyConditionReportPage from "./components/admin/Sf009NInitialSiteElectricalSafetyConditionReportPage";
import Sf009OWeeklySmallPlantInspectionRecordPage from "./components/admin/Sf009OWeeklySmallPlantInspectionRecordPage";
import IncidentReportSf003CPage from "./components/admin/IncidentReportSf003CPage";
import UkpnPPMPage from "./components/admin/UkpnPPMPage";
import MewpChecklistPage from "./components/admin/MewpChecklistPage";
import Sf004GPlantIssueFormPage from "./components/admin/Sf004GPlantIssueFormPage";
import Sf004IBlueTowerPartsChecklistPage from "./components/admin/Sf004IBlueTowerPartsChecklistPage";
import Sf004JRedTowerPartsChecklistPage from "./components/admin/Sf004JRedTowerPartsChecklistPage";
import LserFormPage from "./components/admin/LserFormPage";
import UkpnMstPage from "./components/admin/UkpnMstPage";
import UkpnTbsPage from "./components/admin/UkpnTbsPage";
import UkpnReactivePage from "./components/admin/UkpnReactivePage";
import UkpnAdditionalConcernsPage from "./components/admin/UkpnAdditionalConcernsPage";
import TtslDailyWorksheetPage from "./components/admin/TtslDailyWorksheetPage";
import DailyWorksheetPage from "./components/admin/DailyWorksheetPage";
import AdminPanelLayout from "./components/admin/AdminPanelLayout";
import DynamicFormBuilder from "./components/admin/DynamicFormBuilder";
import DynamicFormDisplay from "./components/admin/DynamicFormDisplay";
import Profile from "./components/admin/Profile";
import Register from "./components/auth/register";
import Dashboard from "./components/account/dashboard/dashboard";
import SiteRegister from "./components/forms/SiteRegister";
import RAMS from "./components/forms/RAMS";
import POWAssessment from "./components/forms/POWAssessment";
import WorkAtHeight from "./components/forms/WorkAtHeight";
import WorkAtHeightPage from "./components/admin/WorkAtHeightPage";
import PPMReportPage from "./components/admin/PPMReportPage";
import PowAssessmentPage from "./components/admin/PowAssessmentPage";
import PreFabricatedPage from "./components/admin/PreFabricatedPage";
import AdditionalConcernsPage from "./components/admin/AdditionalConcernsPage";
import LserPpmDailyChecklistPage from "./components/admin/LserPpmDailyChecklistPage";
import AccidentReportPage from "./components/admin/AccidentReportPage";
import AsbestosBriefingPage from "./components/admin/AsbestosBriefingPage";
import HandArmVibrationPage from "./components/admin/HandArmVibrationPage";
import MEWPChecklist from "./components/forms/MEWPChecklist";
import PPMReport from "./components/forms/PPMReport";
import UKPNPPM from "./components/forms/UKPNPPM";
import LSERCallout from "./components/forms/LSERCallout";
import OnCallEmergencyForm from "./components/forms/OnCallEmergencyForm";
import PreFabricated from "./components/forms/PreFabricated";
import AccidentReport from "./components/forms/AccidentReport";
import AsbestosBriefing from "./components/forms/AsbestosBriefing";
import AdditionalConcerns from "./components/forms/AdditionalConcerns";
import UKPNReactive from "./components/forms/UKPNReactive";
import DailyWorksheet from "./components/forms/DailyWorksheet";
import TTSDailyWorksheet from "./components/forms/TTSDailyWorksheet";
import LSERPPMDailyChecklist from "./components/forms/LSERPPMDailyChecklist";
import UKPNMST from "./components/forms/UKPNMST";
import TBSUKPN from "./components/forms/TBSUKPN";
import SiteRegisterListPage from "./components/forms/SiteRegisterListPage";
import FileUpload from "./components/admin/FileUpload";
import Calendar from "./components/admin/Calendar";
import OutstandingCallPage from "./components/admin/OutstandingCallPage";
import SoutheasternNewEntry from "./components/admin/SoutheasternNewEntry";
import OutstandingQuotesPage from "./components/admin/OutstandingQuotesPage";
import ReturnVisitsPage from "./components/admin/ReturnVisitsPage";
import OutstandingPPMsPage from "./components/admin/OutstandingPPMsPage";
import EntryDataPage from "./components/admin/EntryDataPage";
import UkpnEntryDataPage from "./components/admin/UKPNEntryDataPage";
import UkpnNewEntry from "./components/admin/UkpnNewEntry";
import SitesBeingUpgradedPage from "./components/admin/SitesBeingUpgradedPage";
import TeamPage from "./components/admin/TeamPage";
import SubAdminsPage from "./components/admin/SubAdminsPage";
import ManagersPage from "./components/admin/ManagersPage";
import DirectorsPage from "./components/admin/DirectorsPage";
import SitesPage from "./components/admin/SitesPage";
import AppUpdatePage from "./components/admin/AppUpdatePage";
import AssetManagementPage from "./components/admin/AssetManagementPage";
import AssetQrLabelsPage from "./components/admin/AssetQrLabelsPage";
import AssetsListPage from "./components/admin/AssetsListPage";
import AssetTicketsPage from "./components/admin/AssetTicketsPage";
import FatigueManagementPage from "./components/admin/FatigueManagementPage";
import FatigueWorkSheetsPage from "./components/admin/FatigueWorkSheetsPage";
import SiteVisitsViewPage from "./components/admin/SiteVisitsViewPage";
import BillingReportPage from "./components/admin/BillingReportPage";
import FatigueWorkSheetsStandbyPage from "./components/admin/FatigueWorkSheetsStandbyPage";
import FatigueWorkSheetOnCallPage from "./components/admin/FatigueWorkSheetOnCallPage";
import FatigueShiftsPage from "./components/admin/FatigueShiftsPage";
import FatigueReportsPage from "./components/admin/FatigueReportsPage";
import FatigueExceedanceFormsPage from "./components/admin/FatigueExceedanceFormsPage";
import DFatigueManagementPlanPage from "./components/admin/DFatigueManagementPlanPage";
import SettingsPage from "./components/admin/SettingsPage";
import FormErrorLogsPage from "./components/admin/FormErrorLogsPage";
import ApiFormsLogsPage from "./components/admin/ApiFormsLogsPage";
import SharePointSyncPage from "./components/admin/SharePointSyncPage";
import FormSubmissionsPage from "./components/admin/FormSubmissionsPage";
import RolesPermissionsPage from "./components/admin/RolesPermissionsPage";
import SecretKeyManagerPage from "./components/admin/SecretKeyManagerPage";
import { getStoredRole, isEngineer } from "./utils/rolePermissions";
import { isFormPath, getAllFormPaths } from "./components/admin/formsMenuTree";
// Get current user role from localStorage.
// Deny by default: an unknown/missing role must not fall through to "admin".
function getAdminRole() {
  return getStoredRole();
}

// Where an engineer lands instead of the admin dashboard: the first form in the menu.
function engineerLandingPath() {
  return getAllFormPaths()[0] || "/admin";
}

// Catch-all: handle invalid/wrong URLs (e.g. /admin/dashboarddemo)
function InvalidRoute() {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname || "";
    const token = localStorage.getItem("token");
    if (path.startsWith("/admin")) {
      const home = isEngineer() ? engineerLandingPath() : "/admin/dashboard";
      navigate(token ? home : "/admin", { replace: true });
    } else {
      navigate("/", { replace: true });
    }
  }, [location.pathname, navigate]);
  return null;
}

// Initialize push notifications when user is logged in (token in localStorage)
function PushNotificationInit() {
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    let unsub = () => {};
    requestPermissionAndRegister(token).then(() => {
      onForegroundMessage((payload) => {
        const title = payload?.notification?.title || "Notification";
        const body = payload?.notification?.body || "";
        toast.info(body ? `${title}: ${body}` : title, { autoClose: 5000 });
      }).then((fn) => { unsub = fn; });
    });

    return () => { unsub(); };
  }, []);
  return null;
}

function App() {
  const AdminEntryRoute = () => {
    const token = localStorage.getItem("token");
    if (token) {
      return <Navigate to={isEngineer() ? engineerLandingPath() : "/admin/dashboard"} replace />;
    }
    return <AdminLogin />;
  };

  // Auth wrapper for protected routes.
  // Engineers are confined to the forms section: any other /admin route bounces
  // them back to their landing form. The backend enforces the same restriction
  // (middleware/engineerAccessGuard.js) - this is UX, not the security boundary.
  const RequireAuth = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const token = localStorage.getItem("token");
    const engineerBlocked = token && isEngineer() && !isFormPath(location.pathname);
    React.useEffect(() => {
      if (!token) {
        navigate("/admin", { replace: true });
      } else if (engineerBlocked) {
        navigate(engineerLandingPath(), { replace: true });
      }
    }, [token, engineerBlocked, navigate]);
    if (!token || engineerBlocked) return null;
    return children;
  };

  // Role-based route guard: only allowed roles can access (e.g. SubAdmins/Managers pages for admin only)
  const RequireAdminRole = ({ children, allowedRoles }) => {
    const navigate = useNavigate();
    const role = getAdminRole();
    const allowed = Array.isArray(allowedRoles) ? allowedRoles : ["admin"];
    React.useEffect(() => {
      if (!allowed.includes(role)) {
        navigate("/admin/dashboard", { replace: true });
      }
    }, [role, allowed, navigate]);
    if (!allowed.includes(role)) return null;
    return children;
  };

  return (
    <div className="App">
      <Router>
        <PushNotificationInit />
        <ErrorBoundary>
        <Routes>
          <Route path="/admin/daily-worksheet" element={
            <RequireAuth>
              <AdminPanelLayout>
                <DailyWorksheetPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/" element={<Navigate to="/admin" replace />} />
          <Route path="/register" element={<Register />} />
          <Route path="/admin" element={<AdminEntryRoute />} />
          <Route path="/managers" element={<ManagerLogin />} />
          <Route path="/admin/dashboard" element={
            <RequireAuth>
              <AdminDashboardLayout />  
            </RequireAuth>
          } />
          <Route path="/admin/app-users" element={
            <RequireAuth>
              <AdminPanelLayout>
                <AppUsersPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/settings" element={
            <RequireAuth>
              <RequireAdminRole allowedRoles={["admin"]}>
                <AdminPanelLayout>
                  <SettingsPage />
                </AdminPanelLayout>
              </RequireAdminRole>
            </RequireAuth>
          } />
          <Route path="/admin/secret-key" element={
            <RequireAuth>
              <RequireAdminRole allowedRoles={["admin", "subAdmin"]}>
                <AdminPanelLayout>
                  <SecretKeyManagerPage />
                </AdminPanelLayout>
              </RequireAdminRole>
            </RequireAuth>
          } />
          <Route path="/admin/form-error-log" element={
            <RequireAuth>
              <RequireAdminRole allowedRoles={["admin"]}>
                <AdminPanelLayout>
                  <FormErrorLogsPage />
                </AdminPanelLayout>
              </RequireAdminRole>
            </RequireAuth>
          } />
          <Route path="/admin/sharepoint-sync" element={
            <RequireAuth>
              <RequireAdminRole allowedRoles={["admin", "subAdmin"]}>
                <AdminPanelLayout>
                  <SharePointSyncPage />
                </AdminPanelLayout>
              </RequireAdminRole>
            </RequireAuth>
          } />
          <Route path="/admin/api-forms-logs" element={
            <RequireAuth>
              <RequireAdminRole allowedRoles={["admin"]}>
                <AdminPanelLayout>
                  <ApiFormsLogsPage />
                </AdminPanelLayout>
              </RequireAdminRole>
            </RequireAuth>
          } />
          <Route path="/admin/form-submissions" element={
            <RequireAuth>
              <RequireAdminRole allowedRoles={["admin"]}>
                <AdminPanelLayout>
                  <FormSubmissionsPage />
                </AdminPanelLayout>
              </RequireAdminRole>
            </RequireAuth>
          } />
          <Route path="/admin/roles-permissions" element={
            <RequireAuth>
              <RequireAdminRole allowedRoles={["admin", "subAdmin"]}>
                <AdminPanelLayout>
                  <RolesPermissionsPage />
                </AdminPanelLayout>
              </RequireAdminRole>
            </RequireAuth>
          } />
          <Route path="/admin/sub-admins" element={
            <RequireAuth>
              <RequireAdminRole allowedRoles={["admin"]}>
                <AdminPanelLayout>
                  <SubAdminsPage />
                </AdminPanelLayout>
              </RequireAdminRole>
            </RequireAuth>
          } />
          <Route path="/admin/managers" element={
            <RequireAuth>
              <RequireAdminRole allowedRoles={["admin", "subAdmin"]}>
                <AdminPanelLayout>
                  <ManagersPage />
                </AdminPanelLayout>
              </RequireAdminRole>
            </RequireAuth>
          } />
          <Route path="/admin/directors" element={
            <RequireAuth>
              <RequireAdminRole allowedRoles={["admin"]}>
                <AdminPanelLayout>
                  <DirectorsPage />
                </AdminPanelLayout>
              </RequireAdminRole>
            </RequireAuth>
          } />
          <Route path="/admin/sites" element={
            <RequireAuth>
              <AdminPanelLayout>
                <SitesPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/app-update" element={
            <RequireAuth>
              <RequireAdminRole allowedRoles={["admin"]}>
                <AdminPanelLayout>
                  <AppUpdatePage />
                </AdminPanelLayout>
              </RequireAdminRole>
            </RequireAuth>
          } />
          <Route path="/admin/asset-management" element={
            <RequireAuth>
              <RequireAdminRole allowedRoles={["admin", "subAdmin", "manager"]}>
                <AdminPanelLayout>
                  <AssetManagementPage />
                </AdminPanelLayout>
              </RequireAdminRole>
            </RequireAuth>
          } />
          <Route path="/admin/asset-management/qr-labels" element={
            <RequireAuth>
              <RequireAdminRole allowedRoles={["admin", "subAdmin", "manager"]}>
                <AdminPanelLayout>
                  <AssetQrLabelsPage />
                </AdminPanelLayout>
              </RequireAdminRole>
            </RequireAuth>
          } />
          <Route path="/admin/asset-management/assets" element={
            <RequireAuth>
              <RequireAdminRole allowedRoles={["admin", "subAdmin", "manager"]}>
                <AdminPanelLayout>
                  <AssetsListPage />
                </AdminPanelLayout>
              </RequireAdminRole>
            </RequireAuth>
          } />
          <Route path="/admin/asset-management/tickets" element={
            <RequireAuth>
              <RequireAdminRole allowedRoles={["admin", "subAdmin", "manager"]}>
                <AdminPanelLayout>
                  <AssetTicketsPage />
                </AdminPanelLayout>
              </RequireAdminRole>
            </RequireAuth>
          } />
          <Route path="/admin/fatigue" element={
            <RequireAuth>
              <AdminPanelLayout>
                <FatigueManagementPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/fatigue/work-sheets/standby" element={
            <RequireAuth>
              <AdminPanelLayout>
                <FatigueWorkSheetsStandbyPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/fatigue/work-sheets/on-call/:entryId" element={
            <RequireAuth>
              <AdminPanelLayout>
                <FatigueWorkSheetOnCallPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/fatigue/work-sheets/visits/:entryId" element={
            <RequireAuth>
              <AdminPanelLayout>
                <SiteVisitsViewPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/fatigue/billing-report" element={
            <RequireAuth>
              <AdminPanelLayout>
                <BillingReportPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/fatigue/work-sheets" element={
            <RequireAuth>
              <AdminPanelLayout>
                <FatigueWorkSheetsPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/fatigue/shifts" element={
            <RequireAuth>
              <AdminPanelLayout>
                <FatigueShiftsPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/fatigue/fatigue-rules-list" element={
            <RequireAuth>
              <AdminPanelLayout>
                <FatigueReportsPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/fatigue/exceedance-forms" element={
            <RequireAuth>
              <AdminPanelLayout>
                <FatigueExceedanceFormsPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/fatigue/d-fatigue-management-plan" element={
            <RequireAuth>
              <AdminPanelLayout>
                <DFatigueManagementPlanPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/site-register" element={
            <RequireAuth>
              <AdminPanelLayout>
                <SiteRegisterPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/form/refusal-to-work-form/sign/:id" element={
            <RequireAuth>
              <RefusalToWorkFormSignaturePage />
            </RequireAuth>
          } />
          <Route path="/admin/refusal-to-work-form/sign/:id" element={
            <RequireAuth>
              <RefusalToWorkFormSignaturePage />
            </RequireAuth>
          } />
          <Route path="/admin/refusal-to-work-form" element={
            <RequireAuth>
              <AdminPanelLayout>
                <RefusalToWorkFormPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/ppe-self-check-form" element={
            <RequireAuth>
              <AdminPanelLayout>
                <PPESelfCheckFormPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/permit-to-break-ground" element={
            <RequireAuth>
              <AdminPanelLayout>
                <PermitToBreakGroundPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/hseq-site-inspection" element={
            <RequireAuth>
              <AdminPanelLayout>
                <HseqSiteInspectionPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/rail-hseq-site-inspection" element={
            <RequireAuth>
              <AdminPanelLayout>
                <RailHseqSiteInspectionPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/injured-person-statement" element={
            <RequireAuth>
              <AdminPanelLayout>
                <InjuredPersonStatementPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/behavioural-exchange-engineers" element={
            <RequireAuth>
              <AdminPanelLayout>
                <BehaviouralExchangeEngineersPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/hot-works-permit" element={
            <RequireAuth>
              <AdminPanelLayout>
                <HotWorksPermitPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/witness-statement" element={
            <RequireAuth>
              <AdminPanelLayout>
                <WitnessStatementPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/sf-009-a-certificate-electrical" element={
            <RequireAuth>
              <AdminPanelLayout>
                <Sf009ACertificateElectricalPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/sf-009-b-electrical-isolation" element={
            <RequireAuth>
              <AdminPanelLayout>
                <Sf009BElectricalIsolationPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/sf-009-d-electrical-permit-to-work" element={
            <RequireAuth>
              <AdminPanelLayout>
                <Sf009DElectricalPermitToWorkPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/sf-009-e-electrical-sanction-to-test" element={
            <RequireAuth>
              <AdminPanelLayout>
                <Sf009EElectricalSanctionToTestPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/sf-009-f-limitation-of-access" element={
            <RequireAuth>
              <AdminPanelLayout>
                <Sf009FLimitationOfAccessPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/sf-009-g-register-of-competent-persons" element={
            <RequireAuth>
              <AdminPanelLayout>
                <Sf009GRegisterOfCompetentPersonsPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/sf-009-h-electrical-audit-inspection-report" element={
            <RequireAuth>
              <AdminPanelLayout>
                <Sf009HElectricalAuditInspectionReportPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/sf-009-i-switch-room-electrical-safety-log" element={
            <RequireAuth>
              <AdminPanelLayout>
                <Sf009ISwitchRoomElectricalSafetyLogPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/sf-009-j-risk-assessment-schedule" element={
            <RequireAuth>
              <AdminPanelLayout>
                <Sf009JRiskAssessmentSchedulePage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/sf-009-k-risk-assessment-template" element={
            <RequireAuth>
              <AdminPanelLayout>
                <Sf009KRiskAssessmentTemplatePage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/sf-009-c-site-permit-register" element={
            <RequireAuth>
              <AdminPanelLayout>
                <Sf009CSitePermitRegisterPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/sf-009-l-appointment-authorised-person-assessment" element={
            <RequireAuth>
              <AdminPanelLayout>
                <Sf009LAppointmentAuthorisedPersonAssessmentPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/sf-009-m-acceptance-lv-electrical-safety-rules" element={
            <RequireAuth>
              <AdminPanelLayout>
                <Sf009MAcceptanceLvElectricalSafetyRulesPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/sf-009-n-initial-site-electrical-safety-condition-report" element={
            <RequireAuth>
              <AdminPanelLayout>
                <Sf009NInitialSiteElectricalSafetyConditionReportPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/sf-009-o-weekly-small-plant-inspection-record" element={
            <RequireAuth>
              <AdminPanelLayout>
                <Sf009OWeeklySmallPlantInspectionRecordPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/incident-report-sf003c" element={
            <RequireAuth>
              <AdminPanelLayout>
                <IncidentReportSf003CPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/ukpn-ppm" element={
            <RequireAuth>
              <AdminPanelLayout>
                <UkpnPPMPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/mewp-checklist" element={
            <RequireAuth>
              <AdminPanelLayout>
                <MewpChecklistPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/sf-004-g-plant-issue-form" element={
            <RequireAuth>
              <AdminPanelLayout>
                <Sf004GPlantIssueFormPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/sf-004-i-blue-tower-parts-checklist" element={
            <RequireAuth>
              <AdminPanelLayout>
                <Sf004IBlueTowerPartsChecklistPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/sf-004-j-red-tower-parts-checklist" element={
            <RequireAuth>
              <AdminPanelLayout>
                <Sf004JRedTowerPartsChecklistPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/lser-form" element={
            <RequireAuth>
              <AdminPanelLayout>
                <LserFormPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
           <Route path="/admin/ukpn-mst" element={
             <RequireAuth>
               <AdminPanelLayout>
                 <UkpnMstPage />
               </AdminPanelLayout>
             </RequireAuth>
           } />
          <Route path="/admin/work-at-height" element={
            <RequireAuth>
              <AdminPanelLayout>
                <WorkAtHeightPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/ppm-report" element={
            <RequireAuth>
              <AdminPanelLayout>
                <PPMReportPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/pow-assessment" element={
            <RequireAuth>
              <AdminPanelLayout>
                <PowAssessmentPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/pre-fabricated" element={
            <RequireAuth>
              <AdminPanelLayout>
                <PreFabricatedPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/additional-concerns" element={
            <RequireAuth>
              <AdminPanelLayout>
                <AdditionalConcernsPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/accident-report" element={
            <RequireAuth>
              <AdminPanelLayout>
                <AccidentReportPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/asbestos-briefing" element={
            <RequireAuth>
              <AdminPanelLayout>
                <AsbestosBriefingPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/hand-arm-vibration" element={
            <RequireAuth>
              <AdminPanelLayout>
                <HandArmVibrationPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/ukpn-tbs" element={
            <RequireAuth>
              <AdminPanelLayout>
                <UkpnTbsPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/ukpn-reactive" element={
            <RequireAuth>
              <AdminPanelLayout>
                <UkpnReactivePage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/ukpn-additional-concerns" element={
            <RequireAuth>
              <AdminPanelLayout>
                <UkpnAdditionalConcernsPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/ttsl-daily-worksheet" element={
            <RequireAuth>
              <AdminPanelLayout>
                <TtslDailyWorksheetPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/lser-ppm-daily-checklist" element={
            <RequireAuth>
              <AdminPanelLayout>
                <LserPpmDailyChecklistPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/file-upload" element={
            <RequireAuth>
              <AdminPanelLayout>
                <FileUpload />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/calendar" element={
            <RequireAuth>
              <AdminPanelLayout>
                <Calendar />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/calendar/:fileName" element={
            <RequireAuth>
              <AdminPanelLayout>
                <Calendar />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/team" element={
            <RequireAuth>
              <AdminPanelLayout>
                <TeamPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/southeastern/outstanding-call" element={
            <RequireAuth>
              <AdminPanelLayout>
                <OutstandingCallPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/southeastern/outstanding-quotes" element={
            <RequireAuth>
              <AdminPanelLayout>
                <OutstandingQuotesPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/southeastern/return-visit" element={
            <RequireAuth>
              <AdminPanelLayout>
                <ReturnVisitsPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/southeastern/outstanding-ppms" element={
            <RequireAuth>
              <AdminPanelLayout>
                <OutstandingPPMsPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
          <Route path="/admin/southeastern/entry-data" element={
            <RequireAuth>
              <AdminPanelLayout>
                <EntryDataPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
      <Route path="/admin/form-builder" element={
        <RequireAuth>
          <AdminPanelLayout>
            <DynamicFormBuilder />
          </AdminPanelLayout>
        </RequireAuth>
      } />
      <Route path="/admin/southeastern/new-entry" element={
            <RequireAuth>
              <AdminPanelLayout>
                <SoutheasternNewEntry />
              </AdminPanelLayout>
            </RequireAuth>
          } />
      <Route path="/admin/ukpn/entry-data" element={
            <RequireAuth>
              <AdminPanelLayout>
                <UkpnEntryDataPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
      <Route path="/admin/ukpn/new-entry" element={
            <RequireAuth>
              <AdminPanelLayout>
                <UkpnNewEntry />
              </AdminPanelLayout>
            </RequireAuth>
          } />
      <Route path="/admin/ukpn/sites-being-upgraded" element={
            <RequireAuth>
              <AdminPanelLayout>
                <SitesBeingUpgradedPage />
              </AdminPanelLayout>
            </RequireAuth>
          } />
      <Route path="/admin/dynamic-forms/:formName" element={
        <RequireAuth>
          <AdminPanelLayout>
            <DynamicFormDisplay />
          </AdminPanelLayout>
        </RequireAuth>
      } />
          <Route path="/admin/profile" element={
            <RequireAuth>
              <Profile />
            </RequireAuth>
          } />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/site-register" element={<SiteRegister />} />
          <Route path="/site-register-list/:userId" element={<SiteRegisterListPage />} />
          <Route path="/site-register-list" element={<SiteRegisterListPage />} />
          <Route path="/rams" element={<RAMS />} />
          <Route path="/pow-assessment" element={<POWAssessment />} />
          <Route path="/work-at-height" element={<WorkAtHeight />} />
          <Route path="/mewp-checklist" element={<MEWPChecklist />} />
          <Route path="/ppm-report" element={<PPMReport />} />
          <Route path="/ukpn-ppm" element={<UKPNPPM />} />
          <Route path="/lser-callout" element={<LSERCallout />} />
          <Route path="/on-call-emergency" element={<OnCallEmergencyForm />} />
          <Route path="/pre-fabricated" element={<PreFabricated />} />
          <Route path="/accident-report" element={<AccidentReport />} />
          <Route path="/asbestos-briefing" element={<AsbestosBriefing />} />
          <Route path="/additional-concerns" element={<AdditionalConcerns />} />
          <Route path="/ukpn-reactive" element={<UKPNReactive />} />
          <Route path="/daily-worksheet" element={<DailyWorksheet />} />
          <Route path="/tts-daily-worksheet" element={<TTSDailyWorksheet />} />
          <Route path="/lser-ppm-daily-checklist" element={<LSERPPMDailyChecklist />} />
          <Route path="/ukpn-mst" element={<UKPNMST />} />
          <Route path="/tbs-ukpn" element={<TBSUKPN />} />
          <Route path="*" element={<InvalidRoute />} />
        </Routes>
        </ErrorBoundary>
      </Router>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
}

export default App;